export const ScannerStatusHeader = ({
  scannerState = "idle",
  market = "spot",
  botStatus = "stopped",
  health = "healthy",
  updatedAt = "-",
}) => {
  const normalizedState = String(scannerState || "idle");
  return (
    <header className="rounded-2xl border border-slate-200 bg-white p-5" data-testid="scanner-status-header-card">
      <h1 className="text-4xl font-semibold text-slate-900" data-testid="scanner-status-header-title">Scanner</h1>
      <p className="mt-1 text-sm text-slate-600" data-testid="scanner-status-header-subtitle">Üretim ekranı: ne taranıyor, nasıl taranıyor, neden sinyal çıkmadı.</p>
      <div className="mt-4 grid gap-2 text-sm sm:grid-cols-2 lg:grid-cols-5" data-testid="scanner-status-header-metrics">
        <p data-testid="scanner-status-header-scanner-status">Durum: <strong>{normalizedState}</strong></p>
        <p data-testid="scanner-status-header-market">Market: <strong>{market}</strong></p>
        <p data-testid="scanner-status-header-health">Health: <strong>{health}</strong></p>
        <p data-testid="scanner-status-header-bot-status">Bot: <strong>{botStatus}</strong></p>
        <p data-testid="scanner-status-header-updated">Updated: <strong>{updatedAt}</strong></p>
      </div>
    </header>
  );
};
